import { render, staticRenderFns } from "./renovacion.vue?vue&type=template&id=0f6bf267"
import script from "./renovacion.vue?vue&type=script&lang=js"
export * from "./renovacion.vue?vue&type=script&lang=js"
import style0 from "./renovacion.vue?vue&type=style&index=0&id=0f6bf267&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports